import { render } from "./CategoryCard.vue?vue&type=template&id=7243d42a&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"

import "./CategoryCard.vue?vue&type=style&index=0&id=7243d42a&scoped=true&lang=css"

import exportComponent from "/var/www/zaytoon-sudani-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7243d42a"]])

export default __exports__